import { storageKeys } from '@/constants/storage';
import {
  BNPL_EXPERIMENT_VARIANTS,
  type BnplExperimentVariant,
  type LdEntryType,
} from '@/utils/tracking/ldEvents';

import { createPaymentReturnStorage } from './paymentReturnStorage';
import type { StorageAdapter } from './paymentReturnStorage';

export type LdCheckoutContext = {
  cartId: string;
  shopId: string;
  enrolled: boolean;
  variant: BnplExperimentVariant;
  entryType: LdEntryType;
  method: string;
  totalDollars: number;
  createdAt: number;
};

function isLdCheckoutContext(data: unknown): data is LdCheckoutContext {
  if (typeof data !== 'object' || data === null) return false;
  const obj = data as Record<string, unknown>;
  return (
    typeof obj.cartId === 'string' &&
    typeof obj.shopId === 'string' &&
    typeof obj.method === 'string' &&
    typeof obj.enrolled === 'boolean' &&
    typeof obj.totalDollars === 'number' &&
    typeof obj.createdAt === 'number' &&
    BNPL_EXPERIMENT_VARIANTS.includes(obj.variant as BnplExperimentVariant) &&
    (obj.entryType === 'guest' || obj.entryType === 'authenticated')
  );
}

const localStorageAdapter: StorageAdapter = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
};

const ldStorage = createPaymentReturnStorage(
  storageKeys.ldCheckoutContext,
  isLdCheckoutContext,
  localStorageAdapter,
);

export const getLdCheckoutContext = ldStorage.get;
export const setLdCheckoutContext = ldStorage.set;
export const clearLdCheckoutContext = ldStorage.clear;
